import mime from 'mime-types'
import {generateUploadCredentialsMutation} from './mutations'

export default async function (client, file) {
  const {data} = await client.mutate({
    mutation: generateUploadCredentialsMutation,
    variables: {
      name: file.name.normalize(),
      size: file.size,
      type: file.type || mime.lookup(file.name) || 'application/octet-stream'
    }
  })

  return data.result
}
